export const isFetching = state => state.accounts.list.fetching;
export const list = state => state.accounts.list.list;
export const accounts = state => state.accounts.list.list.accounts;
export const fields = state => state.accounts.list.list.fields || [];
export const preferences = state => state.accounts.list.list.preferences;
export const error = state => state.accounts.list.error;
